import React, { useState } from "react"
import { useGetPhoneSupportNumberForUser } from "#/components/dynamic-content/hooks/useQueryPhoneSupport"
import { Tile, Stack, Typography, Button } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { TwilioVoiceWidget } from "#/components/talk-to-carrot/VoiceWidget/TwilioVoiceWidget"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"

export const OtherWaysToContactCarrotTile = () => {
  const { data: phoneSupportNumber, isInitialLoading: isPhoneSupportNumberLoading } = useGetPhoneSupportNumberForUser()
  const shouldDisplayPhoneSupport = Boolean(phoneSupportNumber?.e164FormatPhoneNumber)
  const [openFiveNineWidget, setOpenFiveNineWidget] = useState(false)
  const { mutate: trackAction } = useMemberActionTracking()

  const handleCallCarrotClick = () => {
    trackAction({
      memberActionTaken: MemberActions.CARE_TEAM_OTHER_CONTACT_CALL_CLICKED
    })
    return shouldDisplayPhoneSupport
      ? window.open(`tel:${phoneSupportNumber?.e164FormatPhoneNumber}`, "_self")
      : setOpenFiveNineWidget(true)
  }

  return (
    !isPhoneSupportNumberLoading && (
      <Tile variant="secondary" color="green">
        <Stack gap={(theme) => theme.tokens.spacing.md}>
          <Typography variant="h4">
            <FormattedMessage defaultMessage="Other ways to contact Carrot" />
          </Typography>
          <Stack gap={(theme) => theme.tokens.spacing.sm}>
            <Stack gap={(theme) => theme.tokens.spacing.xs}>
              <Typography variant="h5">
                <FormattedMessage defaultMessage="Call us" />
              </Typography>
              {shouldDisplayPhoneSupport ? (
                <Typography>
                  <FormattedMessage
                    defaultMessage="Need help now? Talk to one of our Carrot Companions at {phoneNumber}"
                    values={{
                      phoneNumber: phoneSupportNumber?.internationalFormatPhoneNumber
                    }}
                  />
                </Typography>
              ) : (
                <Typography>
                  <FormattedMessage defaultMessage="Need help now? Talk to one of our Carrot Companions online" />
                </Typography>
              )}
            </Stack>
            <Button
              onClick={handleCallCarrotClick}
              color="secondary"
              variant="outlined"
              fullWidth={false}
              sx={{ inlineSize: "fit-content" }}
              data-analytics-id="care-team-other-ways-contact-call-button"
            >
              <FormattedMessage defaultMessage="Call us" />
            </Button>
            <TwilioVoiceWidget open={openFiveNineWidget} setOpen={setOpenFiveNineWidget} />
          </Stack>
        </Stack>
      </Tile>
    )
  )
}
